import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import {
  collection,
  query,
  onSnapshot,
  updateDoc,
  doc,
  increment,
  addDoc,
} from "firebase/firestore";
import "./Voting.css";

const categories = [
  { field: "scariest", label: "Scariest Costume", singlesOnly: true },
  { field: "sexiest", label: "Sexiest Costume", singlesOnly: true },
  { field: "cutest", label: "Cutest Costume", singlesOnly: true },
  { field: "funniest", label: "Funniest Costume", singlesOnly: true },
  { field: "bestDIY", label: "Best DIY Costume", singlesOnly: true },
  { field: "bestCouples", label: "Best Couples Costume", couplesOnly: true },
  { field: "bestOverall", label: "Best Costume (Champion)", singlesOnly: true }
];

function Voting() {
  const [costumes, setCostumes] = useState([]);
  const [selected, setSelected] = useState({});
  const [voterName, setVoterName] = useState("");
  const [submitted, setSubmitted] = useState(false);

  // fetch costumes
  useEffect(() => {
    const q = query(collection(db, "costumes"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const entries = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCostumes(entries);
    });

    return () => unsubscribe();
  }, []);

  const handleSelect = (categoryField, costumeId) => {
    if (submitted) return;
    setSelected((prev) => ({
      ...prev,
      [categoryField]: costumeId,
    }));
  };

  const submitVotes = async () => {
    try {
      if (!costumes.length) {
        alert("Costumes not ready yet, please try again.");
        return;
      }

      const detailedSelections = {};

      for (const [categoryField, costumeId] of Object.entries(selected)) {
        if (!costumeId) continue;

        const costume = costumes.find((c) => c.id === costumeId);

        // increment tallies
        const docRef = doc(db, "costumes", costumeId);
        await updateDoc(docRef, {
          [`votes.${categoryField}`]: increment(1),
        });

        detailedSelections[categoryField] = {
          costumeId,
          costumeName: costume ? costume.name : "Unknown",
        };
      }

      const ballot = {
        voterName,
        selections: detailedSelections,
        timestamp: new Date(),
      };

      await addDoc(collection(db, "votes"), ballot);

      setSubmitted(true);
      alert("Thank you for your votes! We will announce the winners once all votes are in. 🎃");
    } catch (error) {
      console.error("Error submitting votes:", error);
      alert("Something went wrong!");
    }
  };

  const missingCategories = categories
    .filter((cat) => !selected[cat.field])
    .map((cat) => cat.label);

  return (
    <div className="voting-page">
      <div className="voting-content">

        {missingCategories.length > 0 && !submitted && (
          <p style={{ color: "red", marginTop: "10px", marginBottom: "25px" }}> 
            You must choose your favorite costume in each category before submitting.
          </p>
        )}

        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <label style={{ marginRight: "20px" }}>Your Name*:</label>
          <input
            type="text"
            value={voterName}
            onChange={(e) => setVoterName(e.target.value)}
            style={{ padding: "6px", borderRadius: "4px", border: "1px solid #ccc" }}
          />
        </div>

        {categories.map((cat) => {
          let filtered = costumes;
          if (cat.singlesOnly) filtered = filtered.filter((c) => c.category === "Single");
          if (cat.couplesOnly) filtered = filtered.filter((c) => c.category === "Couple");

          return (
            <div key={cat.field} className="voting-category">
              <h2>{cat.label}</h2>
              <div
                style={{
                  display: "flex",
                  overflowX: "auto",
                  overflowY: "hidden",
                  gap: "8px",
                }}
              >
                {filtered.map((c) => (
                  <div
                    key={c.id}
                    className="costume-card"
                    onClick={() => handleSelect(cat.field, c.id)}
                    style={{
                      border: selected[cat.field] === c.id ? "2px solid" : "2px solid",
                      borderColor: selected[cat.field] === c.id ? "#fe6601" : "#b08d69",
                    }}
                  >
                    <img src={c.photoURL} alt={c.name} />
                    <p>{c.name}</p>
                  </div>
                ))}
              </div>
            </div>
          );
        })}

        <button
          className="submit-button"
          onClick={submitVotes}
          disabled={submitted || missingCategories.length > 0 || !voterName}
        >
          {submitted ? "Votes Submitted!" : "Submit Votes"}
        </button>
      </div>
    </div>
  );
}

export default Voting;
